module.exports = __webpack_public_path__ + "img/main_14.cf4a99c6.jpg";